export const SIDE_DRAWER_WIDTH_PX = 360;

export const sideDrawerSlideTransition = {
  type: 'tween' as const,
  duration: 0.35,
  ease: [0.32, 0.72, 0, 1] as [number, number, number, number],
};

export const sideDrawerSlideMotion = {
  initial: { x: SIDE_DRAWER_WIDTH_PX },
  animate: { x: 0 },
  exit: { x: SIDE_DRAWER_WIDTH_PX },
  transition: sideDrawerSlideTransition,
};

export const sideDrawerBackdropMotion = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: {
    duration: 0.35,
    ease: 'easeOut' as const,
  },
};
